import ResponseRegisterContainers from '../../../containers/common/responseRegister/responseRegisterContainers';

function ResponseRegister() {
  return <ResponseRegisterContainers />;
}

export default ResponseRegister;
